module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-costume-2bd21c2a9dcd608de860e609f408d3cf.png";